import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";

type MapUrlProvider = "APPLE" | "GOOGLE" | "GENERIC";

const mapUrlZodSchema = z.object({
    type: z.enum(["GOOGLE", "APPLE", "GENERIC"]) as z.ZodSchema<MapUrlProvider>,
    title: translatableZodSchema.optional(),
    url: z.string().url(),
});

type MapUrl = z.infer<typeof mapUrlZodSchema>;

const googleMapsRegex = new RegExp("google|goo\\.gl", "ig");
const createMapUrl = (params: { title?: Translatable; url: string }) => {
    const type: MapUrlProvider = params.url.match(googleMapsRegex)
        ? "GOOGLE"
        : params.url.includes("maps.apple.com")
        ? "APPLE"
        : "GENERIC";

    return {
        type,
        title: params.title,
        url: params.url,
    };
};

export { createMapUrl, mapUrlZodSchema };
export type { MapUrl, MapUrlProvider };
